export const clearCache = () => {
    if (window.RahmetApp.clearCache) {
        window.RahmetApp.clearCache();
    }
};
